/**
 * RF-03 do PRD 32 — o formato canônico de CRM da folha de monitoramento: `12345-SP`.
 * Vale tanto para o item da lista de sugestões quanto para o valor gravado na célula
 * pelo preenchimento cruzado (RF-04).
 *
 * Puro de propósito: nenhuma decisão de UI depende dele, e a spec o descreve como
 * padrão de apresentação — a digitação livre do auditor nunca passa por aqui.
 */

export type CrmParts = {
  number?: string | null
  uf?: string | null
}

/** `{ number: '12345', uf: 'sp' }` → `12345-SP`. Sem número, não há CRM a exibir. */
export function formatCrm(crm: CrmParts): string {
  const number = String(crm.number ?? '').trim()
  if (!number) return ''

  const uf = String(crm.uf ?? '')
    .trim()
    .toUpperCase()
  return uf ? `${number}-${uf}` : number
}

/** RF-03 — item da lista de sugestões, no formato `NOME — 12345-SP`. */
export function formatDoctorSuggestion(suggestion: CrmParts & { name: string }): string {
  const name = String(suggestion.name ?? '').trim()
  const crm = formatCrm(suggestion)
  return crm ? `${name} — ${crm}` : name
}
